import axios from 'axios';
import { api } from '../../api/api';
import apiError from '../../api/api-error';
import localStorage from '../localStorage'

import { isCookieEnabled, getCookie, removeCookie } from 'tiny-cookie';

// initial state
const state = {
   rec: null,
   token: null,
   customer: null
};

const COOKIE = 'scout';

// getters
const getters = {
   getToken: ()=>{
      return localStorage.get(COOKIE)
   }
};

// actions
const actions = {
   AGENT_INIT: async function(context){
      let token = localStorage.get(COOKIE)
      // if the token was found in localStorage, overwrite the cookie with its value
      if (!token) token = getCookie(COOKIE);
      if (!token) return;

      const agent = await context.dispatch('AGENT_GET',{token})
      if (!agent) return;

      context.commit('AGENT_TOKEN_SET', {token});

      await context.dispatch('PLAN_CURRENT')
   },
   AGENT_GET: async (context, {token})=>{
      const res = await api.get('/api/agent',{params:{token}});
      if (!res || !res.data) return null;
      context.commit('AGENT_REC_SET', {rec: res.data});
      if (res.data.customer && res.data.customer.stripeCustomer){
         context.commit('STRIPE_CUSTOMER_SET', {customer: res.data.customer.stripeCustomer})
      }
      return res.data;
   },
   // AGENT_LOGIN will issue a user login request against the API error
   // optional hideError parameter can be used to supresses the 
   // error from agent login, which is helpful during a multi steped network
   // operation.
   // TODO: refactor so hideError is not necessary. This shold be managed 
   // by the caller.
   AGENT_LOGIN: (context, {email, password, hideError = false})=>{ 
      return new Promise((resolve, reject)=>{
         api.post('/api/login',{
            email: email,
            password: password
         })
         .then((res)=>{
            localStorage.set(COOKIE, res.data.token);
            context.commit('AGENT_TOKEN_SET', {token:res.data.token});
            context.dispatch('PLAN_CURRENT').then(()=>{
               resolve();
            });
         })
         .catch((error)=>{
            
            if (!hideError) context.commit('ERROR_MESSAGE_SET',{message:'error logging in, check your email and password'});
            reject(error);
         });
      });
   },
   // AGENT_SIGNUP will issue a signup request against the API.
   // The optional hideError parameter can be used to supresses the error 
   // from agent login, which is helpful during a multi steped network
   // operation.
   // TODO: refactor so hideError is not necessary. This shold be managed 
   // by the caller.
   AGENT_SIGNUP: (context, {email, password, hideError = false})=>{
      return new Promise((resolve, reject)=>{
         api.post('/api/signup',{
            email: email,
            password: password
         })
         .then((res)=>{
            localStorage.set(COOKIE, res.data.token);
            context.commit('AGENT_TOKEN_SET', {token:res.data.token});
            context.dispatch('PLAN_CURRENT').then(()=>{
               context.commit('PLAN_LOADED_SET', true);
               resolve();
            });
         })
         .catch((error)=>{
            if (hideError) return reject(error)
            if (error.response.data.error === 'email already signed up'){
               context.commit('ERROR_MESSAGE_SET',{message:'email already signed up'});
            } else {
               context.commit('ERROR_MESSAGE_SET',{message:'error signing up, check your email and password'});
            }
            reject(error);
         });
      });
   },
   AGENT_LOGOUT: (context)=>{
      return new Promise((resolve, reject)=>{
         context.commit('AGENT_TOKEN_REMOVE', {token: null});
         context.commit('STRIPE_CUSTOMER_SET', {customer:null});
         context.dispatch('STRIPE_CARD_CLEAR');
         context.dispatch('PLAN_CLEAR');
         resolve();
      });
   },
   AGENT_CUSTOMER_GET: function(context){
      return new Promise((resolve, reject)=>{
         api.get('/api/agent/customer',{})
         .then((res)=>{
            context.commit('STRIPE_CUSTOMER_SET', {customer:res.data.stripeCustomer});
            resolve(res);
         })
         .catch((error)=>{
            // sniff for certain status codes
            switch(error.response.status){
               // unauthorized, the user is logged out
               case 401: 
                  return resolve();
               case 404: 
                  return resolve();
               case 406:
                  return resolve();
            }
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('customer',error)});

            reject(error);
         });
      });
   },
   AGENT_EMAIL_CHANGE: (context, {userId, email})=>{
      return new Promise((resolve, reject)=>{
         api.patch('/api/users/'+userId+'/email',{
            email: email,
         })
         .then((res)=>{
            context.commit('AGENT_EMAIL_SET',{email});
            resolve();
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('email change',error)});
            reject(error);
         });
      });
   },
   AGENT_RESET_PASSWORD: (context, {email})=>{
      return new Promise((resolve, reject)=>{
         api.post('/api/users/forgot-password/send',{
            email: email,
         })
         .then((res)=>{
            resolve();
         })
         .catch((error)=>{
            context.commit('ERROR_MESSAGE_SET',{message:apiError.message('email reset send',error)});
            reject(error);
         });
      });
   },

};

// mutations
const mutations = {
   AGENT_EMAIL_SET: (state, {email})=>{
      state.rec = {...state.rec, email};
   },
   AGENT_REC_SET: (state, {rec})=>{
      state.rec = rec;
   },
   AGENT_TOKEN_SET: (state, {token})=>{
      axios.defaults.headers.common['Authorization'] = 'BEARER ' + token; // set the Auth token for all axios calls
      state.token = token;
   },
   AGENT_TOKEN_REMOVE: (state, {token})=>{
      removeCookie(COOKIE);
      localStorage.set(COOKIE, null);
      axios.defaults.headers.common['Authorization'] = '';
      state.token = null;
   }
};

export default {
   state,
   getters,
   actions,
   mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/agent.js